import { render } from "./zlDetail.vue?vue&type=template&id=c22d60fe&scoped=true"
import script from "./zlDetail.vue?vue&type=script&lang=js"
export * from "./zlDetail.vue?vue&type=script&lang=js"

import "./zlDetail.vue?vue&type=style&index=0&id=c22d60fe&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c22d60fe"]])

export default __exports__